
import { useQuery } from "@tanstack/react-query";
import {
  getGoals,
  getModels,
  getReports,
  getPersonas,
  getSystemStatus,
  getSelfEvaluationStats,
  getExperimentTimeline,
  getChatStats,
  getAchievements,
  getResearchQueries,
  getMemoryLengthData
} from "@/services/apiService";

export const useGoalsData = () => {
  return useQuery({
    queryKey: ["goals"],
    queryFn: getGoals,
  });
};

export const useModelsData = () => {
  return useQuery({
    queryKey: ["models"],
    queryFn: getModels,
  });
};

export const useReportsData = () => {
  return useQuery({
    queryKey: ["reports"],
    queryFn: getReports,
  });
};

export const usePersonas = () => {
  return useQuery({
    queryKey: ["personas"],
    queryFn: getPersonas,
  });
};

export const useSystemStatus = () => {
  return useQuery({
    queryKey: ["systemStatus"],
    queryFn: getSystemStatus,
  });
};

export const useSelfEvaluationStats = () => {
  return useQuery({
    queryKey: ["selfEvaluationStats"],
    queryFn: getSelfEvaluationStats,
  });
};

export const useExperimentTimeline = () => {
  return useQuery({
    queryKey: ["experimentTimeline"],
    queryFn: getExperimentTimeline,
  });
};

export const useChatStats = () => {
  return useQuery({
    queryKey: ["chatStats"],
    queryFn: getChatStats,
  });
};

export const useAchievements = () => {
  return useQuery({
    queryKey: ["achievements"],
    queryFn: getAchievements,
  });
};

export const useResearchQueries = () => {
  return useQuery({
    queryKey: ["researchQueries"],
    queryFn: getResearchQueries,
  });
};

export const useMemoryLengthData = () => {
  return useQuery({
    queryKey: ["memoryLengthData"],
    queryFn: getMemoryLengthData,
  });
};
